var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnhideIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1C2.63636 1 1 5 1 5C1 5 2.63636 9 7 9C11.3636 9 13 5 13 5C13 5 11.3636 1 7 1ZM7 2C9.87782 2 11.3334 4.13355 11.8047 4.99805C11.3329 5.85655 9.86636 8 7 8C4.12218 8 2.66659 5.86645 2.19531 5.00195C2.66768 4.14345 4.13364 2 7 2ZM7 3C5.79509 3 4.81818 3.8955 4.81818 5C4.81818 6.1045 5.79509 7 7 7C8.20491 7 9.18182 6.1045 9.18182 5C9.18182 3.8955 8.20491 3 7 3ZM7 4C7.60273 4 8.09091 4.4475 8.09091 5C8.09091 5.5525 7.60273 6 7 6C6.39727 6 5.90909 5.5525 5.90909 5C5.90909 4.4475 6.39727 4 7 4Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1L1 9",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnhideIcon);
export default __webpack_public_path__ + "static/media/UnhideIcon.ab8f386543ca5204409d2f759390bb20.svg";
export { ForwardRef as ReactComponent };